'use strict';
require('../../modules/esnext.object.iterate-values');
var path = require('../../internals/path');

module.exports = path.Object.iterateValues;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/iterate-values.js
// module id = 366
// module chunks = 0